import * as React from "react";
import { useStaticQuery, graphql } from "gatsby";

type FooterQuery = {
  contentfulComponentFooter: {
    first: string | null;
  } | null;
};

const Footer: React.FC<{ isHome?: boolean }> = ({ isHome }) => {
  const data = useStaticQuery<FooterQuery>(graphql`
    query FooterData {
      contentfulComponentFooter {
        first
      }
    }
  `);

  const first = data.contentfulComponentFooter?.first ?? "";

  if (!first) return null;

  return (
    <footer className={`site-footer${isHome ? " site-footer--home" : ""}`}>
      <p className="site-footer-line">{first}</p>
    </footer>
  );
};

export default Footer;
